import { Picker } from 'antd-mobile';
import { useEffect, useState } from 'react';
import { hMacAjax as fetch } from '@/httpService';
import s from './index.module.scss';
import MultipleSelect from './MultipleSelect';
import { RightOutline } from 'antd-mobile-icons';
// data_source_type 1自定义  2平台数据源
const SelectForm = (props) => {
    const [visible, setVisible] = useState(false);
    let { setting = {}, updated, desc, formInstance, formDisabled } = props;

    const disabled = formDisabled === undefined ? updated !== 0 : formDisabled,
        [options, setOptions] = useState([]);
    const [value, setValue] = useState([]);

    // todo 请求后端数据源接口
    let getOptions = () => {
        // setTimeout(() => {
        //     setOptions([{ id: 1, name: '平台数据源' }]);
        // }, 500);

        fetch.get(setting.requestUrl).then((res) => {
            if (res.success) {
                let items = [];
                for (let i = 0; i < res.data?.length; i++) {
                    let item = {
                        id: res.data[i]['id'],
                        name: res.data[i]['org_name'],
                        value: res.data[i]['id'],
                        label: res.data[i]['org_name']
                    };
                    items.push(item);
                }
                setOptions(items);
            }
        });
    };
    useEffect(() => {
        if (setting.data_source_type === 1) {
            let enabledOption = setting.options.filter((ele) => ele.enabled === true);

            enabledOption.forEach((v) => {
                v.value = v.id;
                v.label = v.name;
            });
            setOptions(enabledOption);
            if (props.en_name === 'org_id') {
                setValue([props.value] || []);
            } else {
                Array.isArray(props.value) ? setValue(props.value) : setValue([props.value]);
            }
        } else {
            getOptions();
        }
    }, []);
    const closePicker = () => {
        setVisible(false);
    };
    const openPicker = () => {
        if (!disabled) {
            setVisible(true);
        }
    };
    if (setting.type === 'single' || props.en_name === 'org_id') {
        return (
            <>
                {options && options.length > 0 ? (
                    <Picker
                        onCancel={closePicker}
                        visible={visible}
                        columns={[options]}
                        value={value}
                        className="aaaa"
                        disabled={disabled}
                        destroyOnClose={true}
                        onConfirm={(val) => {
                            setValue(val);
                            //格式是数组，取第一个元素，和pc端保持一致
                            formInstance.setFieldsValue({
                                [props.en_name]: val[0]
                            });
                            closePicker();
                        }}
                    >
                        {(items, { open }) => {
                            if (items.every((item) => item === null)) {
                                return (
                                    <div className={s['dynamic-cascade-item']} onClick={openPicker}>
                                        {desc || '请选择 '} <RightOutline fontSize={12} style={{ marginLeft: 8 }} color="#999999" />
                                    </div>
                                );
                            }
                            return (
                                <div className={s['dynamic-cascade-item-value']} onClick={openPicker}>
                                    {items.map((item) => item?.label).join('-')}
                                </div>
                            );
                        }}
                    </Picker>
                ) : null}
            </>
        );
    }
    return <MultipleSelect {...props} options={options} />;
};
export default SelectForm;
